import {findIndex} from 'lodash'
import { useFormik } from 'formik'
import {object, string, number} from 'yup'
import { ValidationError } from 'components/validation-error/ValidationError'

export const Labels = [
  'person',
  'bicycle',
  'car',
  'motorcycle',
  'airplane',
  'bus',
  'train',
  'truck',
  'boat',
  'traffic light',
  'fire hydrant',
  'stop sign',
  'parking meter',
  'bench',
  'bird',
  'cat',
  'dog',
  'horse',
  'sheep',
  'cow',
  'elephant',
  'bear',
  'zebra',
  'giraffe',
  'backpack',
  'umbrella',
  'handbag',
  'tie',
  'suitcase',
  'frisbee',
  'skis',
  'snowboard',
  'sports ball',
  'kite',
  'baseball bat',
  'baseball glove',
  'skateboard',
  'surfboard',
  'tennis racket',
  'bottle',
  'wine glass',
  'cup',
  'fork',
  'knife',
  'spoon',
  'bowl',
  'banana',
  'apple',
  'sandwich',
  'orange',
  'broccoli',
  'carrot',
  'hot dog',
  'pizza',
  'donut',
  'cake',
  'chair',
  'couch',
  'potted plant',
  'bed',
  'dining table',
  'toilet',
  'tv',
  'laptop',
  'mouse',
  'remote',
  'keyboard',
  'cell phone',
  'microwave',
  'oven',
  'toaster',
  'sink',
  'refrigerator',
  'book',
  'clock',
  'vase',
  'scissors',
  'teddy bear',
  'hair drier',
  'toothbrush'
]

export const CensorshipRuleSet = props => {
  const {
    rules = [],
    onChange = () => {},
  } = props

  const formik = useFormik({
    initialValues: {
      class: '',
      accuracy: '',
      limit: '',
    },
    validationSchema: object().shape({
      class: string().required('Object class is required to add rule'),
      accuracy: number().required('Trusted accuracy percentage is required'),
      limit: number().required('Camera feed percentage is required')
    }),
    onSubmit: async payload => {
      console.log(payload)


      const next = [...rules]
      const index = findIndex(next, r => r.class === payload.class)
      if (index === -1) {
        onChange([...next, payload])
      } else {
        next.splice(index, 1, payload)
        onChange(next)
      }

      formik.handleReset()
    },
    enableReinitialize: true
  })

  const remove = (index) => {
    const next = [...rules]
    next.splice(index, 1)
    onChange(next)
  }

  return (
    <div>
      <div className="d-flex">
        <div className="flex-grow-1 mr-2">
          <label>Obtrusion class</label>
          <select
            className="form-control"
            onChange={(e) => formik.setFieldValue('class', e.target.value)}
          >
            <option disabled selected value>
              -- Select label --
            </option>
            {Labels.map(item => (
              <option key={item} value={item} selected={formik.values.class === item}>
                {item}
              </option>
            ))}
          </select>
          <ValidationError formik={formik} property="class" />
        </div>
        <div className="mr-2">
          <label>Accuracy percentage(%)</label>
          <input
            pattern="[0-9]*"
            type="number"
            className="form-control"
            placeholder="0-100"
            value={formik.values.accuracy}
            onChange={(e) => formik.setFieldValue('accuracy', Number(e.target.value))}
          />
          <ValidationError formik={formik} property="accuracy" />
        </div>
        <div className="mr-2">
          <label>Percentage(%) of camera feed</label>
          <input
            pattern="[0-9]*"
            type="number"
            className="form-control"
            placeholder="0-100"
            value={formik.values.limit}
            onChange={(e) => formik.setFieldValue('limit', Number(e.target.value))}
          />
          <ValidationError formik={formik} property="limit" />
        </div>
        <div>
          <label>&nbsp;</label>
          <div>
            <button type="button" className="btn btn-primary" onClick={formik.handleSubmit}>
              <i className="fal fa-check"></i>
            </button>
          </div>
        </div>
      </div>

      {
        rules.length ? (
          <div className="mt-2">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Obtrusion class</th>
                  <th scope="col">Accuracy percentage(%)</th>
                  <th scope="col">Percentage(%) of camera feed</th>
                  <th scope="col">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {rules.map((item, index) => (
                  <tr key={`rule-${index}`}>
                    <td>{item.class}</td>
                    <td>{item.accuracy}%</td>
                    <td>{item.limit}%</td>
                    <td>
                      <i role="button" className="fal fa-trash text-danger" onClick={() => remove(index)}></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null
      }
    </div>
  )
}
